import cn from 'classnames';
import { useRef, useState } from 'react';
import { ButtonUI } from 'sonata-react-components';

import './menuDropdown.scss';

import { useClickOutside } from '../../../hooks/useClickOutside';

export type MenuDropdownItem = {
  id: string;
  icon?: string;
  title: string;
  subtitle?: string;
  onClick?: () => void;
  isButton?: boolean;
};

type Props = {
  items: MenuDropdownItem[];
  title: string;
  icon?: string;
  image?: string;
  subtitle?: string;
  options?: {
    isMenuItem?: boolean;
    isSelected?: boolean;
  };
};

export function MenuDropdown({ options, items, title, subtitle, icon, image }: Readonly<Props>) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLButtonElement>(null);
  useClickOutside(ref, () => setIsOpen(false));

  const handleToggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const showImage = image || icon;

  return (
    <button
      aria-expanded={isOpen}
      className={cn('menuDropdown', {
        'menuDropdown--menuItem': options?.isMenuItem,
        'menuDropdown--opened': isOpen,
        'menuDropdown--selected': options?.isSelected
      })}
      onClick={handleToggleOpen}
      ref={ref}
      type="button"
    >
      <div className="menuDropdown__container">
        {showImage && (
          <div className="menuDropdown__image">
            {image ? (
              <img alt="userImage" className="menuDropdown__imageImg" src={image} />
            ) : (
              <div className="menuDropdown__imageIcon">
                <span className={icon} />
              </div>
            )}
          </div>
        )}
        <div className="menuDropdown__texts">
          <span className="menuDropdown__textsTitle">{title}</span>
          {subtitle && <span className="menuDropdown__textsSubtitle">{subtitle}</span>}
        </div>
        <span className={`menuDropdown__caret fa-regular fa-chevron-${isOpen ? 'up' : 'down'}`} />
        {isOpen && (
          <div className="menuDropdown__content">
            {items.map(item =>
              item.isButton ? (
                <ButtonUI
                  className="menuDropdown__button"
                  icon={item.icon}
                  iconPosition="right"
                  key={item.id}
                  onClick={item.onClick}
                  size="ultraSmall"
                  text={item.title}
                />
              ) : (
                <button className="menuDropdown__item" key={item.id} onClick={item.onClick} type="button">
                  {item.icon && <span className={`menuDropdown__itemIcon ${item.icon}`} />}
                  <div className="menuDropdown__itemText">
                    <div className="menuDropdown__itemTitle">{item.title}</div>
                    {item.subtitle && <div className="menuDropdown__itemSubtitle">{item.subtitle}</div>}
                  </div>
                </button>
              )
            )}
          </div>
        )}
      </div>
    </button>
  );
}
